import { ReviewsStore, ReviewsResponse } from '../types';
import { extractReviewsAllPhotos } from './extract-reviews-all-photos';
import {
  extractFacetsByScore,
  extractReviews,
  extractReviewsPageMeta,
  extractTotalRating,
  extractTotalRatingBy,
} from './response-processor';

export const processFetchedResult = (data: ReviewsResponse): ReviewsStore => {
  return {
    productId: data.product.product_id,
    recommended: data.product.recommended,
    rating: {
      total: extractTotalRating(data),
      byPrice: extractTotalRatingBy('price', data),
      byQuality: extractTotalRatingBy('quality', data),
    },
    facets: {
      byScore: extractFacetsByScore(data),
    },
    reviewsCards: extractReviews(data),
    allPhotos: extractReviewsAllPhotos(data),
    pageMeta: extractReviewsPageMeta(data),
  };
};
